import CreateInvitationButton from "@/invitation/create/button/CreateInvitationButton"
import ProductMembersListPageToolbar from "@/product/member/page/ProductMembersListPageToolbar"
import useProductMembersListToolbarState from "@/product/member/page/useProductMembersListToolbarState"
import { ExperienceAdminsListSkeleton } from "@/product/settings/ExperienceAdminsList"
import ExperienceMembershipsTable from "@/product/settings/ExperienceMembershipsTable"
import {
  ExperienceSettingsMembershipsTabFragment$key,
  ProductType,
} from "@/product/settings/__generated__/ExperienceSettingsMembershipsTabFragment.graphql"
import Relay from "@/relay/relayUtils"
import { DiscoButton, DiscoButtonSkeleton, DiscoIcon, DiscoText } from "@disco-ui"
import { observer } from "mobx-react-lite"
import { useFragment } from "react-relay"
import { graphql } from "relay-runtime"
import styles from "./ExperienceSettingsMembershipsTab.module.css"

interface Props {
  experienceKey: ExperienceSettingsMembershipsTabFragment$key
}

function ExperienceSettingsMembershipsTab({ experienceKey }: Props) {
  const product = useFragment<ExperienceSettingsMembershipsTabFragment$key>(
    graphql`
      fragment ExperienceSettingsMembershipsTabFragment on Product {
        id
        name
        type
        ...ProductMembersListPageToolbarFragment
      }
    `,
    experienceKey
  )

  const { toolbarState, setToolbarState } = useProductMembersListToolbarState(
    product.type as Extract<ProductType, "course" | "pathway">
  )

  if (!product) return null

  return (
    <>
      <div className={styles.header}>
        <DiscoText variant={"body-md-600"}>{"Active Members"}</DiscoText>

        <CreateInvitationButton productId={product.id}>
          {(createInvitationButtonnProps) => (
            <DiscoButton
              {...createInvitationButtonnProps}
              leftIcon={<DiscoIcon icon={"add"} />}
              testid={"ExperienceSettingsMembershipsTab.CreateInvitationButton"}
              onlyIconInMobile
            >
              {"Invite"}
            </DiscoButton>
          )}
        </CreateInvitationButton>
      </div>

      <ProductMembersListPageToolbar
        productKey={product}
        toolbarState={toolbarState}
        setToolbarState={setToolbarState}
        filterButtonVariant={"icon"}
        sortButtonVariant={"icon"}
        showExportCsvButton
        sortOptions={["member_name", "role", "joined_on"]}
      />
      <ExperienceMembershipsTable productId={product.id} toolbarState={toolbarState} />
    </>
  )
}

export const ExperienceSettingsMembershipsTabSkeleton = () => {
  return (
    <>
      <ExperienceAdminsListSkeleton />
      <DiscoButtonSkeleton width={"100%"} />
    </>
  )
}

export default Relay.withSkeleton<Props>({
  component: observer(ExperienceSettingsMembershipsTab),
  skeleton: ExperienceSettingsMembershipsTabSkeleton,
})
